<template>
  <div class="export-sidebar">
    <div class="header d-flex w-100 align-items-center py-2 px-4">
      <a :href="`/dashboard/report_list?type=${selectedExportReport.type}`">
        <v-icon dense color="#3F3F3F" size="24">mdi-arrow-left</v-icon>
      </a>
      <div>
        <template v-if="isTruncated">
          <v-tooltip bottom max-width="280px">
            <template v-slot:activator="{ on, attrs }">
              <h3 ref="reportTitle" class="ma-0 font-bold" v-bind="attrs" v-on="on" style="width: 350px;">
                {{ truncate(selectedExportReport.name || '') }}
              </h3>
            </template>
            <span>{{ selectedExportReport.name }}</span>
          </v-tooltip>
        </template>
        <h3 v-else class="ma-0 font-bold" style="width: 350px; text-wrap: no-wrap;">{{ selectedExportReport.name }}</h3>
        <h6 class="ma-0 mt-2">{{ mappedType }}</h6>
      </div>
    </div>

    <div v-if="reportType === 'Report::Sales'" class="export-select mx-6 mt-4">
      <div role="button" @click="exportSelect = 'template'" class="export-choice"
        :class="{ selected: exportSelect === 'template' }">Report Template</div>
      <div role="button" @click="exportSelect = 'collection'" class="export-choice"
        :class="{ selected: exportSelect === 'collection' }">Collection</div>
    </div>

    <template v-if="exportSelect === 'template'">
      <div class="report-container">
        <div class="report-content">
          <div class="px-6 mt-3 d-flex justify-content-between align-items-center">
            <h5 class="font-bold"
              style="max-width: 70%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">Columns</h5>
            <a v-if="selectedExportReport && isAdminsRole"
              :href="`/dashboard/template_builder/${selectedExportReport.id}`" class="d-flex align-items-center"
              style="color: #2f80ed;">
              <v-icon color="#2f80ed" dense class="mr-1">mdi-pencil-outline</v-icon>
              Edit Template
            </a>
          </div>
          <div v-if="isLoading" class="d-flex justify-content-center align-items-center py-4 h-100">
            <v-progress-circular color="primary" indeterminate></v-progress-circular>
          </div>
          <template v-else>
            <div v-if="sortedReportFields.length" class="report-fields">
              <div v-for="(field, index) in sortedReportFields" :key="index" class="column-item">
                <div v-if="field.category_key === 'Questionnaire::Template'" class="d-flex flex-column ml-2">
                  <b class="mb-1">#{{ field.fieldable_id }} {{ field.header_name || field.original_header_name }}</b>
                  <div v-for="(item, index) in field.csv_header_name" :key="index" class="d-flex flex-column ml-2"
                    style="gap: 4px;">
                    <b style="font-size: 12px;">{{ item }}</b>
                    <i style="color: #848484; font-size: 12px;">{{ item }}</i>
                  </div>
                </div>
                <div v-else class="d-flex flex-column ml-2">
                  <b>{{ getFieldLabel(field) }}</b>
                  <i style="color: #848484; font-size: 12px;">{{ field.original_header_name }}</i>
                </div>
              </div>
            </div>
            <i v-else class="d-flex justify-content-center align-items-center h-100 py-2">No Data</i>
          </template>
        </div>
      </div>
    </template>

    <div v-if="exportSelect === 'collection'" class="py-4 px-6 export-collection">
      <i class="ma-0 export-information mb-4">This will generate a .csv that groups the payments data and calculates the
        value by total paid payment.</i>
      <div class="text-sm mb-2">Group By</div>
      <CSelectNew class="mb-4 text-xs h-auto" v-model="exportGroupBy" :options="groupByOptions" :itemValue="'value'"
        :itemText="'text'"></CSelectNew>
      <div class="text-sm mb-2">Calculated Value</div>
      <CInput class="mb-4 text-xs h-auto" value="Total Paid Payment" disabled></CInput>
      <h5 class="font-bold">Exported Columns</h5>
      <div v-if="sortedCollectionFields.length" class="report-fields p-0 mt-2">
        <div v-for="(field, index) in sortedCollectionFields" :key="index" class="column-item">
          <div class="d-flex flex-column ml-2">
            <b>{{ field.header_name || field.original_header_name }}</b>
            <i style="color: #848484; font-size: 12px;">{{ field.header_name || field.original_header_name }}</i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import CSelectNew from '../../c-select-new.vue';
import CInput from '../../c-input.vue';
import { resolveDynamicFiltersToAbsolute } from '../../../shared/report-filter-helpers';

export default {
  components: {
    CSelectNew,
    CInput,
  },
  data() {
    return {
      sortOptions: [
        { text: "A" },
        { text: "B" },
        { text: "C" },
      ],
      selectedReport: null,
      exportSelect: 'template',
      exportGroupBy: 'contributor',
      groupByOptions: [
        { text: 'Contributor', value: 'contributor' },
        { text: 'Procedure', value: 'procedure' }
      ],
      groupByCalculated: 'total_paid_payment',
      calculatedOptions: [
        { text: 'Total Paid Payment', value: 'total_paid_payment' },
      ],
      collectionColumn: {
        contributor: [
          { id: 1, position: 1, columnName: 'contributor', header_name: 'Contributor', isCollection: true, group: 'contributor' },
          { id: 2, position: 2, columnName: 'total_paid_payment', header_name: 'Total Paid Payment', isCollection: true, group: 'contributor' }
        ],
        procedure: [
          { id: 1, position: 1, columnName: 'procedure', header_name: 'Procedure', isCollection: true, group: 'procedure' },
          { id: 2, position: 2, columnName: 'total_paid_payment', header_name: 'Total Paid Payment', isCollection: true, group: 'procedure' }
        ]
      },
    }
  },
  computed: {
    ...mapState({

    }),
    ...mapGetters({
      reportList: 'reportList/reportList',
      reportFields: 'reportList/reportFields',
      isLoading: 'reportList/isLoading',
      allReportFields: 'reportList/allReportFields',
      mergedFilters: 'reportList/mergedFilters',
      selectedExportReport: "reportList/selectedExportReport",
      currentUser: "reportList/currentUser",
    }),
    sortedReportFields() {
      let fields = this.reportFields.slice().sort((a, b) => a.position - b.position);
      // Hide case_business_unit columns for Join reports
      if (this.reportType === 'Report::Join') {
        fields = fields.filter(field => field.category_key !== 'case_business_unit');
      }
      return fields;
    },
    sortedCollectionFields() {
      return this.allReportFields.slice().sort((a, b) => a.position - b.position);
    },
    isAdminsRole() {
      return this.currentUser?.role === 'institution_admin' || this.currentUser?.role === 'admin' || this.currentUser?.role === 'super_admin'
    },
    reportType() {
      return this.selectedExportReport?.type;
    },
    mappedType() {
      const typeMapping = {
        'Report::Case': 'Case',
        'Report::Client': 'Client',
        'Report::Ticket': 'Ticket',
        'Report::Join': 'Join (Cases & Clients)',
        'Report::Sales': 'Sales',
      };
      return typeMapping[this.selectedExportReport.type] || this.selectedExportReport.type;
    },
    isTruncated() {
      return (this.selectedExportReport.name || '').length > 30;
    },
  },
  mounted() {
    this.$store.commit('reportList/clearSelectedExportReport');
    if (this.$route.params.id) {
      this.selectedReport = this.$route.params.id
    }
    this.$store.commit('reportList/setExportSelect', 'template');
  },
  methods: {
    formattedFilters(filter) {
      // Filter out empty values and format the filter object
      return Object.entries(filter)
        .filter(([_, value]) => value && value !== "" && JSON.stringify(value) !== "[]") // Remove empty values
        .reduce((acc, [key, value]) => {
          acc[this.formatFilterKey(key)] = Array.isArray(value) ? value.join(", ") : value;
          return acc;
        }, {});
    },
    formatFilterKey(key) {
      // Convert snake_case or camelCase to readable format
      return key
        .replace(/_/g, " ") // Replace underscores with spaces
        .replace(/\b\w/g, c => c.toUpperCase()); // Capitalize words
    },
    formatHeaders(headers, isLimited = false) {
      const formatted = headers.map(header => {
        if (Array.isArray(header)) {
          return `<b>${header[0]}</b>`
        }
        return header;
      });

      if (isLimited && formatted.length > 10) {
        return formatted.slice(0, 10).join(', ') + '...';
      }

      return formatted.join(', ');
    },
    hasFilters(filter) {
      return Object.values(filter).some(value => value && value !== "" && JSON.stringify(value) !== "[]");
    },
    truncate(value) {
      if (!value) return '';
      return value.length > 30 ? value.substring(0, 30) + '...' : value;
    },
    async initializeFilters(reportId) {
      const urlParams = new URLSearchParams(window.location.search);
      let queryFilters = {};

      for (let [key, value] of urlParams.entries()) {
        if (key.endsWith("[]")) {
          let cleanKey = key.replace("[]", "");
          if (!queryFilters[cleanKey]) queryFilters[cleanKey] = [];
          queryFilters[cleanKey].push(value === "" ? "" : isNaN(value) ? value : Number(value));
        } else {
          if (value.includes(",")) {
            queryFilters[key] = value
              .split(",")
              .map(v => (v === "" ? "" : isNaN(v) ? v : Number(v)))
              .filter(v => v !== null);
          } else {
            queryFilters[key] = value === "" ? "" : isNaN(value) ? value : Number(value);
          }
        }
      }

      Object.keys(queryFilters).forEach(key => {
        if (Array.isArray(queryFilters[key])) {
          if (queryFilters[key].length === 0 || queryFilters[key].every(v => v === "")) {
            queryFilters[key] = "";
          }
        } else if (queryFilters[key] === null) {
          queryFilters[key] = "";
        }
      });

      let savedFilters = this.selectedExportReport?.filter || {};
      const finalFilters = Object.keys(queryFilters).length > 0 ? queryFilters : savedFilters;
      const resolvedFilters = resolveDynamicFiltersToAbsolute(finalFilters, this.selectedExportReport?.filter_options || []);

      await this.$store.commit('reportList/setMergedFilters', finalFilters);
      await this.$store.commit('reportList/setAppliedFilters', resolvedFilters);
      await this.$store.dispatch('reportList/getPreviewDataIds', { id: reportId, params: resolvedFilters });
    },
    async fetchReportDetails(reportId) {
      await this.$store.commit('reportList/setIsLoading', true);
      await this.$store.commit('reportList/setFieldPagination', { current_page: 1 });
      await this.$store.dispatch('reportList/getExportReportById', reportId);
      await this.$store.dispatch('reportList/getDataCount', { id: reportId });
      await this.$store.dispatch('reportList/getExportReportFields', reportId);
      await this.$store.dispatch('reportList/getAllReportFields', reportId);
      await this.$store.commit('reportList/setIsLoading', false);
    },
    getFieldLabel(field) {
      const name = field.header_name || field.original_header_name;
      if (this.reportType !== 'Report::Client' && ['Business Unit', 'Department'].includes(name)) {
        return `${name} (Client)`;
      }
      return name;
    },
  },
  created() {
  },
  watch: {
    selectedReport(newVal) {
      if (newVal) {
        this.fetchReportDetails(newVal);
      }
    },
    selectedExportReport: {
      handler(newValue) {
        if (newValue && Object.keys(newValue).length > 0) {
          this.initializeFilters(newValue.id);
        }
      },
      immediate: true
    },
    exportSelect(newVal) {
      this.selectedReport = null;
      if (newVal === 'collection') {
        this.$store.commit('reportList/setAllReportFields', this.collectionColumn[this.exportGroupBy]);
      } else {
        this.$store.dispatch('reportList/getAllReportFields', this.$route.params.id);
      }
      this.$store.commit('reportList/setExportSelect', newVal);
    },
    exportGroupBy(newVal) {
      if (this.exportSelect === 'collection') {
        this.$store.commit('reportList/setAllReportFields', this.collectionColumn[newVal]);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.export-sidebar {
  min-width: 448px;
  width: 448px;
  height: 100%;
  background-color: #FFFFFF;
  border-right: 1px solid #D7D7D7;
  display: flex;
  flex-direction: column;
  z-index: 9;

  .header {
    gap: 24px;
    height: 64px !important;
    min-height: 64px !important;
    border-bottom: 1px solid #D7D7D7;

    h3 {
      font-size: 20px;
      color: #3F3F3F;
    }

    h6 {
      font-size: 14px;
      color: #3F3F3F;
    }
  }

  .column-header {
    background-color: #F4F4F4;
  }

  .column-group {
    margin-bottom: 16px;
  }

  .column-group:last-child {
    margin-bottom: 8px;
  }

  .scroll-container {
    flex: 1;
    overflow-y: auto;
    padding: 0 8px 0 16px;
  }

  ::v-deep .btn-outline-secondary {
    color: #3F3F3F !important;
    border-color: #D7D7D7 !important;
  }

  ::v-deep .btn-outline-secondary:hover {
    color: #FFFFFF !important;
    border-color: #FFFFFF !important;
  }

  .filter-item {
    border: 1px solid #D7D7D7;
    border-radius: 4px;
    padding: 8px;
    width: 100%;
    font-size: 12px;

    ul {
      display: flex;
    }
  }

  .column-item {
    width: 100%;
    padding: 8px;
    align-items: center;
    border: 1px solid #D7D7D7;
    border-radius: 4px;
  }

  .report-container {
    height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .no-report {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #F4F4F4;
    margin: 0 24px 18px 24px;
  }

  .report-content {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
  }

  .report-fields {
    flex: 1;
    overflow-y: auto;
    padding: 0 24px;
    max-height: calc(100vh - 200px);
    margin-top: 4px;
  }

  .column-item {
    padding: 8px;
    border: 1px solid #D7D7D7;
    border-radius: 4px;
    margin-bottom: 8px;
  }

  .export-select {
    border: 1px solid #D7D7D7;
    border-radius: 5px;
    padding: 2px;
    display: flex;
  }

  .export-choice.selected {
    color: white;
    background: #007BFF;
  }

  .export-choice {
    color: #3F3F3F;
    font-weight: 700;
    border-radius: 5px;
    width: 50%;
    padding: 0.375rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  ::v-deep .c-select-tag-input:hover {
    background-color: #EDF4FE !important;
  }

  .export-information {
    display: block;
    padding: 0.5rem;
    background: rgba(229, 241, 255, 0.9);
    border-radius: 5px;
  }
}
</style>
